<!-- Logo -->
<div class="sx-topheader__logo sxl-full-height sxl-flex-1" [routerLink]="['/secure/dashboard']" routerLinkActive="router-link-active" >
    <svg>
        <use xlink:href="#stockholm-exergi-flat" href="#stockholm-exergi-flat"/>
    </svg>
</div>

<!-- App launcher -->
<div class="sxh-only-desktop sx-topheader__app-launcher sxl-flex sxl-justify-center sxl-items-center sxl-flex-1">
    @if(isAppLauncherVisible && isIntelligyUser ){
        <nav class="sx-topheader__app-launcher-items sxl-flex sxl-items-center sxl-full-height">
            @for(menuItem of appLauncherMenuItems; track menuItem.id; let i = $index) {
                <span style="height: 100%;" matTooltip="{{menuItem.itemType === itemTypeFunction && menuItem.disabled ? ('core.header.applauncher.intelligy-impersonation-tooltip'| translate) : null }}">
                    @switch (menuItem.itemType) {
                        @case(itemTypeLink){
                            <a href="#" [routerLink]="[menuItem.linkUrl]" class="sxl-full-height" 
                                [ngClass]="{'sx-topheader__app-launcher-active': menuItem.id === activeAppLauncherItem.id }" >
                                    <div class="sx-topheader__app-launcher-item sxl-flex sxl-items-center sxl-full-height">
                                        <span class="sx-topheader__app-launcher-item-text sx-topheader__app-launcher-gtm-trigger-click">
                                            {{menuItem.displayText}}
                                        </span>
                                    </div>
                            </a>
                        }
                        @case(itemTypeFunction){
                            <button  
                                class="sx-navmenu__navbutton sxl-full-height" 
                                id="{{menuItem.id}}"
                                [disabled]="menuItem.disabled"
                                (click)="callbackFunction( menuItem.callbackFunction )"
                                style="background: transparent;">
                                <div class="sx-topheader__app-launcher-item sxl-flex sxl-items-center sxl-full-height">
                                    <div class="sx-topheader__app-launcher-item-text sx-topheader__app-launcher-element--no-border">
                                        <span class="sx-topheader__app-launcher-button-text sx-topheader__app-launcher-item-click sx-topheader__app-launcher-gtm-trigger-click" >
                                            {{ menuItem.displayText }} 
                                        </span>
                                    </div>
                                </div>
                            </button>
                        }
                    }
                </span>            
            }
        </nav> 
    }
</div>

<!-- Tophheader menu -->
<div class="sx-topheader__menu sxl-flex sxl-justify-end sxl-items-center sxl-flex-1">
    @if(isAppLauncherVisible && isIntelligyUser ){
        <nav class="sxh-only-mobile sx-topheader__app-launcher sx-topheader__app-launcher-items sxl-flex sxl-items-center sxl-full-height" 
            style="margin-right: 0.75rem;">
       
            <button class="sx-navmenu__navbutton sx-topheader__app-launcher-active sxl-full-height" id="top_nav_app_launcher" 
                    [ngClass]="{ 'sxl-flex-1': isHandset, 'sx-navmenu__navbutton--active-menu sx-navmenu__navbutton__arrow': appLauncherTrigger.menuOpen}"
                    [matMenuTriggerFor]="appLauncherMenu" 
                    #appLauncherTrigger="matMenuTrigger"
                    style="background: transparent;">
                    <div class="sx-topheader__app-launcher-item sxl-flex sxl-items-center sxl-full-height">
                        <div class="sx-topheader__app-launcher-item-text sx-topheader__app-launcher-element">
                            <span class="sx-topheader__app-launcher-button-text" >
                                {{ activeAppLauncherItem.displayText }} 
                            </span>
                            <span class="sx-topheader__app-launcher-button-icon">
                                <svg>
                                    <use xlink:href="#in-chevron" href="#in-chevron"/>
                                </svg>
                            </span>
                        </div>
                    </div>
            </button>
        
            <mat-menu class="sx-notifications-menu" id="top_nav_app_launcher_menu" #appLauncherMenu="matMenu" yPosition="below" overlapTrigger="false">
                <app-menu [menuItems]="appLauncherMenuItems"></app-menu>
            </mat-menu>
            
        </nav> 
    }
    @if(!isHandset && isLoggedIn ){
        <app-nav-buttons 
            [isHandset]="isHandset"
            [isLoggedIn]="isLoggedIn" 
            [unreadNotificationCount]="unreadNotificationCount" 
            [unreadNotifications]="unreadNotifications$|async" 
            [bannerMessages]="bannerMessages"
            [unreadMessagesCount]="unreadMessagesCount"
            [userInfo]="userInfo" 
            [unreadTipsCount]="unreadTipsCount"
            [meteringPoints]="meteringPoints"
            class="sxl-full-height">
        </app-nav-buttons>        
    }
    <!-- Mobile burger menu -->
     @if(isLoggedIn){
        <nav>
            <button class="sx-topheader__burger" 
                type="button" 
                matTooltip="{{ 'core.header.sidenav' | translate }}"
                aria-label="Toggla huvudmeny" 
                (click)="toggleMenu()">
                <svg>
                    <use xlink:href="#baseline-menu-24px" href="#baseline-menu-24px" />
                </svg>
                <span class="sx-navmenu__total-count" 
                    [matBadge]="mobileTotalNotificationCount"
                    [matBadgeOverlap]="true" 
                    [matBadgeHidden]="mobileTotalNotificationCount === 0">
                </span>
            </button>
        </nav>
     }
</div>
